import React, { useRef, useState } from "react";
import HTMLFlipBook from "react-pageflip";

const pages = [
  "/brochure/brochure_page-0001.jpg",
  "/brochure/brochure_page-0002.jpg",
  "/brochure/brochure_page-0003.jpg",
  "/brochure/brochure_page-0004.jpg",
  "/brochure/brochure_page-0005.jpg",
  "/brochure/brochure_page-0006.jpg",
  "/brochure/brochure_page-0007.jpg",
  "/brochure/brochure_page-0008.jpg",
  "/brochure/brochure_page-0009.jpg",
  "/brochure/brochure_page-0010.jpg",
  "/brochure/brochure_page-0011.jpg",
  "/brochure/brochure_page-0012.jpg",
  "/brochure/brochure_page-0013.jpg",
  "/brochure/brochure_page-0014.jpg",
  "/brochure/brochure_page-0015.jpg",
  "/brochure/brochure_page-0016.jpg",
  "/brochure/brochure_page-0017.jpg",
  "/brochure/brochure_page-0018.jpg",
  "/brochure/brochure_page-0019.jpg",
  "/brochure/brochure_page-0020.jpg",
  "/brochure/brochure_page-0021.jpg",
  "/brochure/brochure_page-0022.jpg",
  "/brochure/brochure_page-0023.jpg",
  "/brochure/brochure_page-0024.jpg",
  "/brochure/brochure_page-0025.jpg",
  "/brochure/brochure_page-0026.jpg",
  "/brochure/brochure_page-0027.jpg",
  "/brochure/brochure_page-0028.jpg",
  "/brochure/brochure_page-0029.jpg",
  "/brochure/brochure_page-0030.jpg",
  "/brochure/brochure_page-0031.jpg",
];


const Brochure = () => {
  const bookRef = useRef();
  const [currentPage, setCurrentPage] = useState(0);

  const totalPages = pages.length;

  const nextPage = () => {
    bookRef.current.pageFlip().flipNext();
  };

  const prevPage = () => {
    bookRef.current.pageFlip().flipPrev();
  };

  return (
    <section className="internal-page-padding-top overflow-hidden">
      <div className="container text-center">
        <div className="row justify-content-center">
          <div className="col-lg-9 col-10">

            <HTMLFlipBook
              width={500}
              height={700}
              size="stretch"
              minWidth={300}
              maxWidth={800}
              minHeight={400}
              maxHeight={1000}
              showCover={true}
              mobileScrollSupport={true}
              drawShadow={true}
              flippingTime={800}
              ref={bookRef}
              onFlip={(e) => setCurrentPage(e.data)}
            >
              {pages.map((src, index) => (
                <div key={index} className="page">
                  <img
                    src={src}
                    alt={`Page ${index + 1}`}
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                    }}
                  />
                </div>
              ))}
            </HTMLFlipBook>

            <div className="d-flex justify-content-center align-items-center gap-3 mt-5">
              <button className="wait-button" onClick={prevPage}>
                Prev
              </button>

              <span>
                Page {currentPage + 1} of {totalPages}
              </span>

              <button className="wait-button" onClick={nextPage}>
                Next
              </button>
            </div>

          </div>
        </div>
      </div>
    </section>
  );
};

export default Brochure;
